import type { ReactNode } from "react";

type HeaderShellProps = Readonly<{
  children: ReactNode;
}>;

export default function HeaderShell({ children }: HeaderShellProps) {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white shadow-sm">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        {children}
      </div>
    </header>
  );
}
